import {
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { AtomAssistPersonaLinkTooltipButton } from "./ModelButtons";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";

export const ModelRelatedPersonas = ({ personas }) => {
  const history = useHistory();

  const handleClickPersona = (e, slug) => {
    e.preventDefault();
    history.push(`/assistant/configs?delete-model-link=${slug}`);
  };

  return (
    <Accordion style={{ marginBottom: "6px" }}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
        data-attr="models:btn:expand-related-personas"
      >
        <Typography component="span">
          Links to Agents that Match this Model
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid
          container
          spacing={1}
          sx={{
            padding: 2,
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(5, 1fr)",
            },
            gap: 1,
            "& .MuiGrid-item": {
              width: "100%",
              minWidth: 0,
            },
          }}
        >
          {personas.map((link, index) => (
            <Grid
              item
              key={index}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <AtomAssistPersonaLinkTooltipButton
                link={link.slug}
                onClick={handleClickPersona}
              />
            </Grid>
          ))}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

ModelRelatedPersonas.propTypes = {
  personas: PropTypes.array.isRequired,
};
